import React from 'react';
import type { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import cs from 'classnames';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useIsSkySlopeMobileApp } from '../../../common/utils';
import { useIsMediumScreenMediaQuery } from '../../../lib/isSmallScreen';
import { MobileMarkupToolSelectionTabs } from './mobile-markup-tool-selection-tabs';

const useStyles = makeStyles(
  (theme: Theme) => ({
    wrapper: {
      position: 'fixed',
      bottom: 12,
      right: theme.spacing(2),
      zIndex: 1200, // material app bar has a high z-index
      justifyContent: 'flex-end',
      display: 'flex',
      width: 'calc(100VW - 400px)',
    },
    wrapperMobile: {
      width: '100%',
      bottom: '0px',
      right: '0px',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderTop: '1px solid #CAD5E0',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
  { name: 'FooterControls' }
);

export function FooterControls(props: { children?: React.ReactNode }) {
  const { children } = props;
  const classes = useStyles();
  const isMdScreenOrSmaller = useIsMediumScreenMediaQuery();
  const isMobileApp = useIsSkySlopeMobileApp();

  return (
    <div id="footer" className={cs(classes.wrapper, isMdScreenOrSmaller && classes.wrapperMobile)}>
      <MobileMarkupToolSelectionTabs />

      {isMobileApp ? null : isMdScreenOrSmaller ? (
        <div className="p-4 w-full flex justify-between">{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
